import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  activeRoute: string = '';
  currentYear: number = new Date().getFullYear();

  constructor(private router: Router, private elRef: ElementRef) {
    this.router.events
      .subscribe((event) => {
        this.activeRoute = this.router.url; // Get current route
      });
  }

  ngOnInit() {
  }

  isActive(route: string): boolean {
    return this.activeRoute === route;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const links = this.elRef.nativeElement.querySelectorAll('a[href="#"]');
      links.forEach(link => {
        link.setAttribute('href', 'javascript:void(0)');
      });
    }, 1000);
  }

}
